import React from 'react';

const Pipe = () => {
  return (
    <div className="page-content">
      {/* OPTION 9: Image Grid Collage Header */}
      <section className="page-hero service-hero-grid" style={{
        position: 'relative',
        minHeight: '500px',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        marginTop: '120px',
        paddingTop: '3rem',
        paddingBottom: '3rem'
      }}>
        {/* Image Grid Background */}
        <div className="service-hero-grid-bg" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '1rem',
          padding: '1rem',
          zIndex: 1
        }}>
          {[...Array(8)].map((_, i) => (
            <div key={i} style={{
              background: `linear-gradient(${135 + i * 20}deg, rgba(0, 104, 166, 0.6) 0%, rgba(171, 22, 54, 0.6) 100%)`,
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span className="material-icons" style={{fontSize: '3rem', color: 'rgba(255, 255, 255, 0.3)'}}>
                {['plumbing', 'precision_manufacturing', 'engineering', 'settings', 'content_cut', 'build_circle', 'water_drop', 'verified'][i]}
              </span>
            </div>
          ))}
        </div>
        
        {/* Dark Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          zIndex: 2
        }}></div>
        
        <div className="container" style={{position: 'relative', zIndex: 3, textAlign: 'center', padding: '4rem 20px'}}>
          <div style={{maxWidth: '800px', margin: '0 auto'}}>
            <div className="service-badge" style={{
              display: 'inline-block',
              fontSize: '0.9rem',
              fontWeight: '600',
              color: 'var(--white)',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              paddingBottom: '0.5rem',
              borderBottom: '3px solid var(--accent-blue)',
              marginBottom: '2rem'
            }}>
              Professional Services
            </div>
            
            <h1 className="service-title" style={{
              color: 'var(--white)',
              fontSize: '4.5rem',
              fontWeight: '700',
              marginBottom: '1.5rem',
              lineHeight: '1.1'
            }}>
              Pipe Shop
            </h1>
            
            <p className="service-subtitle" style={{
              color: 'rgba(255, 255, 255, 0.95)',
              fontSize: '1.5rem',
              lineHeight: '1.6',
              marginBottom: '0'
            }}>
              Advanced pipe fabrication and installation for commercial and mission-critical facilities
            </p>
          </div>
        </div>
      </section>

      {/* Section 1: Technology Based Processes */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Technology Based Processes</h2>
            <p>Advanced CNC and robotic welding for precision pipe fabrication</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
                Each spool is extracted from the model, downloaded to a <strong style={{color: 'var(--accent-blue)'}}>CNC plasma table where the pipe is cut, beveled and prepared for the fit-up process</strong>. Once the pipe spool is assembled it moves to the weld areas where the welds are preformed using computerized and robotic welding processes.
              </p>
              
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)'}}>
                Bel-Aire utilizes the latest technologies in <strong style={{color: 'var(--accent-blue)'}}>Robotic Pipe welding</strong>. We maximize productivity using RMD and Pro-Pulse welding with the benefits of off-site manufacturing, labor reduction, and minimal on-site storage.
              </p>
            </div>
            
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [CNC Plasma Table and Robotic Welding Image]
            </div>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '0 auto'}}>
            <div style={{background: 'var(--secondary-light)', padding: '2.5rem', borderRadius: '10px', marginBottom: '2rem'}}>
              <div style={{textAlign: 'center', marginBottom: '2rem'}}>
                <div style={{display: 'inline-block', background: 'var(--accent-blue)', color: 'var(--white)', padding: '1.5rem 3rem', borderRadius: '50px', boxShadow: '0 6px 25px rgba(0, 104, 166, 0.3)'}}>
                  <p style={{fontSize: '2.5rem', fontWeight: '700', margin: '0 0 0.5rem 0'}}>3" - 36"</p>
                  <p style={{fontSize: '1rem', margin: 0, textTransform: 'uppercase', letterSpacing: '1px'}}>Pipe Manufacturing Range</p>
                </div>
              </div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: 0, textAlign: 'center'}}>
                From small diameter commercial applications to large-scale industrial systems, our advanced manufacturing capabilities deliver precision pipe fabrication for any project requirement.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Commercial Pipe Systems */}
      <section className="section" style={{background: 'linear-gradient(180deg, var(--white) 0%, var(--secondary-light) 100%)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Commercial Pipe Systems</h2>
            <p>Comprehensive piping solutions for commercial and mission-critical facilities</p>
          </div>
          
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center'}} className="precon-grid-2col">
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Commercial Pipe Installation Image]
            </div>
            
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                Bel-Aire Mechanical specializes in <strong style={{color: 'var(--accent-blue)'}}>commercial pipe systems</strong> for data centers, hospitals, and large-scale commercial facilities. Our advanced manufacturing processes ensure precision fabrication for complex piping networks that demand the highest reliability and performance standards.
              </p>
              
              <div style={{background: 'var(--accent-blue)', color: 'var(--white)', padding: '2rem', borderRadius: '10px'}}>
                <h3 style={{color: 'var(--white)', fontSize: '1.3rem', marginBottom: '1rem'}}>Commercial Applications</h3>
                <p style={{fontSize: '1.05rem', lineHeight: '1.7', color: 'rgba(255, 255, 255, 0.95)', margin: 0}}>
                  Our pipe systems serve critical applications including HVAC distribution, process piping, medical gas systems, and emergency systems for mission-critical facilities requiring 24/7 reliability.
                </p>
              </div>
            </div>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '3rem auto 0'}}>
            <div className="pipe-applications-grid" style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(4, 1fr)', 
              gap: '1rem'
            }}>
              <div className="pipe-application-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent-blue)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)', marginBottom: '0.5rem'}}>HVAC Piping</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Chilled water, hot water, and steam distribution systems</p>
              </div>
              <div className="pipe-application-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent2-red)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent2-red)', marginBottom: '0.5rem'}}>Process Piping</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Specialized piping for industrial and commercial processes</p>
              </div>
              <div className="pipe-application-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent-blue)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)', marginBottom: '0.5rem'}}>Medical Gas Systems</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Critical medical gas distribution for healthcare facilities</p>
              </div>
              <div className="pipe-application-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent2-red)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent2-red)', marginBottom: '0.5rem'}}>Emergency Systems</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Fire suppression and emergency water systems</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Pipe Manufacturing Highlights */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Pipe Manufacturing Highlights</h2>
            <p>State-of-the-art equipment and advanced manufacturing capabilities</p>
          </div>
          
          <div style={{maxWidth: '1200px', margin: '0 auto'}}>
            <div className="pipe-highlights-grid" style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(3, 1fr)', 
              gap: '1.5rem'
            }}>
              <div className="pipe-highlight-card pipe-card-blue" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>precision_manufacturing</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '1rem', color: 'var(--white)'}}>Advanced Cutting Technology</h3>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Capable of cutting bevels, saddles, shapes and miters</li>
                  <li>Fully programmable utilizing plasma and fuel gas</li>
                  <li>Data directly download from BIM modeling stations</li>
                  <li>Multiple axis computer controlled pipe cutter</li>
                </ul>
              </div>
              
              <div className="pipe-highlight-card pipe-card-red" style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(171, 22, 54, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>build</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '1rem', color: 'var(--white)'}}>Certified Welding Excellence</h3>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>ASME certified pipe welders</li>
                  <li>Certified welding personnel</li>
                  <li>MIG, TIG and arc welding capabilities</li>
                  <li>Latest computer controlled welding techniques</li>
                </ul>
              </div>
              
              <div className="pipe-highlight-card pipe-card-blue" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>settings</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '1rem', color: 'var(--white)'}}>Robotic Welding Technology</h3>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Manipulator/Oscillator latest pipe welding technology</li>
                  <li>Computer controlled welding for repeatability</li>
                  <li>High degree of accuracy and precision</li>
                  <li>Increased productivity using RMD and Pro Pulse</li>
                </ul>
              </div>
              
              <div className="pipe-highlight-card pipe-card-red" style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(171, 22, 54, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>plumbing</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '1rem', color: 'var(--white)'}}>Manufacturing Capabilities</h3>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Manufacturing pipe sizes from 3" to 36"</li>
                  <li>Ductwork and custom manufacturing</li>
                  <li>Regulated Metal Deposition welding programs</li>
                  <li>Pro Pulse welding programs</li>
                </ul>
              </div>
              
              <div className="pipe-highlight-card pipe-card-blue" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>verified</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '1rem', color: 'var(--white)'}}>Quality & Efficiency</h3>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>X-ray quality welding at 40% cost reduction</li>
                  <li>Increased productivity using advanced programs</li>
                  <li>Minimum waste manufacturing processes</li>
                  <li>Precision fabrication to specification</li>
                </ul>
              </div>
              
              <div className="pipe-highlight-card pipe-card-red" style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(171, 22, 54, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>construction</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '1rem', color: 'var(--white)'}}>Safety & Material Handling</h3>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>3 ton traversing bridge cranes</li>
                  <li>Interior and exterior crane systems</li>
                  <li>Minimizes material handling costs</li>
                  <li>Increased safety during operations</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 4: Photo Grid */}
      <section style={{background: 'var(--secondary-light)', padding: '4rem 0'}}>
        <div className="container">
          <div className="section-header">
            <h2>Pipe Manufacturing in Action</h2>
            <p>Advanced pipe fabrication processes and equipment</p>
          </div>
        </div>
        
        <div style={{width: '100%', padding: '0 2rem'}}>
          <div className="pipe-photo-grid" style={{
            display: 'grid', 
            gridTemplateColumns: 'repeat(3, 1fr)', 
            gap: '1.5rem',
            maxWidth: '1400px',
            margin: '0 auto'
          }}>
            <div className="image-placeholder pipe-photo-item" style={{minHeight: '300px', borderRadius: '10px'}}>
              [CNC Plasma Cutting Table Photo]
            </div>
            <div className="image-placeholder pipe-photo-item" style={{minHeight: '300px', borderRadius: '10px'}}>
              [Robotic Welding Process Photo]
            </div>
            <div className="image-placeholder pipe-photo-item" style={{minHeight: '300px', borderRadius: '10px'}}>
              [Pipe Assembly and Fit-up Photo]
            </div>
            <div className="image-placeholder pipe-photo-item" style={{minHeight: '300px', borderRadius: '10px'}}>
              [Large Diameter Pipe Manufacturing Photo]
            </div>
            <div className="image-placeholder pipe-photo-item" style={{minHeight: '300px', borderRadius: '10px'}}>
              [Quality Control and Testing Photo]
            </div>
            <div className="image-placeholder pipe-photo-item" style={{minHeight: '300px', borderRadius: '10px'}}>
              [Completed Pipe Systems Installation Photo]
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pipe;
